<template>
  <div>
    <PageHeader title="アポロスクール設定" class="main-form">
      <template #title-header-content>
        <div class="flex-1 pl-2 flex ml-6 justify-between items-center">
          <div class="text-white text-xs">
            人事経理総務部・管理者のみ閲覧、編集可能
          </div>

          <div class="pl-2 flex items-center">
            <!-- 開催日 -->
            <input
              type="date"
              placeholder="開催日 検索"
              class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 text-center mr-2"
              v-model="filter.date"
            />

            <!-- キーワード検索 -->
            <input
              type="search"
              placeholder="キーワード 検索"
              class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 mr-2"
              v-model="filter.keyword"
            />

            <!-- 検索ボタン -->
            <PrimaryButton
              text="検索"
              class="button-contents mr-5"
              @click="getData(1)"
            >
            </PrimaryButton>

            <!-- 新規作成 -->
            <div>
              <PrimaryButton text="新規追加" size="normal hover:bg-pink-400" class="new" @click="add()"/>
            </div>
            <Icon
              iconName="Refresh"
              :clickable="false"
              :class="{'animate-spin': loading}"
              class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
              @click.native="refresh"
            />
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-20 w-screen bottom-4 -mt-2 leading-8 main-form">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div v-if="list.length" class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="text-sm w-full">
            <thead class="th sticky top-0 z-20">
              <tr class="text-gray-500 text-xs border border-gray-200 bg-colu font-bold">
                <th v-for="(c, i) in columns" :key="'col'+i" class="text-left p-2" :class="c.class">{{ c.val }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in list" :key="index" class="hover-color border-b" :class="row.edit?'bg-yellow-300':''">
                <!-- 開催日 -->
                <td class="px-2 py-3">
                  <input
                    type="date"
                    :min="today"
                    class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 text-center"
                    v-model="row.day"
                    @change="changeRow(row)"
                  />
                </td>
                <!-- キーワード受付時間 -->
                <td class="px-2 py-3">
                  <div class="flex">
                    <input
                      type="time"
                      class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 text-center"
                      v-model="row.startTime"
                      @change="changeRow(row)"
                    />
                    <p class="font-bold self-center text-lg px-3">～</p>
                    <input
                      type="time"
                      class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 text-center"
                      v-model="row.endTime"
                      @change="changeRow(row)"
                    />
                  </div>
                </td>
                <!-- キーワード -->
                <td class="px-2 py-3 ">
                  <input
                    type="text"
                    placeholder="キーワードを入力してください"
                    class="border border-gray-300 rounded-md focus:bg-white focus:text-gray-900 w-full"
                    v-model="row.keyword"
                    @change="changeRow(row)"
                  />
                </td>
                <td class="px-2 py-3 text-right w-48">
                  <PrimaryButton v-if="row.edit" text="保存" class="w-max mr-1" :class="row.edit?'':'bg-indigo-700'" @click="save(row)" />
                  <PrimaryButton text="削除" class="w-max" @click="deleteData(row, index)" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300 ml-1"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="!loading && !list.length" class="w-full h-full flex justify-center items-center text-gray-400">
          <EmptyMessage
            iconName="Document"
            message="該当するデータはありません。"
          />
        </div>
        <div class="text-transparent text-xs">{{reload}}</div>
        <div v-if="!loading" class="w-fit mx-auto">
          <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import Pagination from 'vue-pagination-2'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

// カラム
const COL = [
  { val: '開催日' },
  { val: 'キーワード受付時間\r\n（時間内しか受け付けません）', class: 'whitespace-pre' },
  { val: 'キーワード' },
  { val: '' },
]

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    EmptyMessage,
    Pagination
  },

  data() {
    return {
      loading: false,
      reload: 0,
      // データ
      list: [],
      // カラム
      columns: utils.clone(COL),
      // 検索
      filter: {
        date: null,
        keyword: null
      },
      // 本日日付
      today: moment().format('YYYY-MM-DD'),

      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 10,
      // 全件数
      records: 0,
    }
  },

  async created() {
    let auth = false
    const dep = this.$store.getters.dualPosition
    if (dep && dep.length) {
      // 人事部か確認
      const isDep = dep.find((d) => {
        return (d.departmentName.indexOf('人事') > -1)
      })
      if (isDep && isDep.departmentName) {
        auth = true
      }
    }
    // 管理者権限の場合
    let auth2 = this.$store.getters.auth
    if (auth2 && auth2.adminAuth) {
      auth = true
    }

    // 権限
    if (!auth) {
      alert('この画面は権限のある人しか見れません。\r\nメニューへ戻ります。')
      this.$router.push('/')
      return
    }

    await this.getData(1)
  },

  methods: {
    async refresh() {
      await this.getData(1)
    },

    /**
     * データ取得
     */
    async getData(num) {
      this.loading = true

      if (num) {
        this.page = num
      }

      let res = await backend.searchData('evaluationActivity/get', { ...this.filter, page: this.page, perPage: this.perPage })
      this.list = res.data.data
      if (this.list.length) {
        this.records = Number(res.data.data[0].records)
      } else {
        this.records = 0
      }

      this.loading = false
    },

    /**
     * 新規追加
     */
    add() {
      const row = {
        day: moment().format('YYYY-MM-DD'),
        startTime: '12:00',
        endTime: '12:10',
        keyword: null,
        edit: true
      }
      this.list.unshift(row)
      this.reload++
    },

    /**
     * 変更
     * @param row
     */
    changeRow(row) {
      row.edit = true
      this.reload++
    },

    /**
     * 削除ボタン イベント
     * @param row 対象データ
     */
    async save(row) {
      row.insertUser = this.$store.getters.user.id
      row.type = 1
      if (!row.day) {
        await dialogs.showErrorDialog('開催日 未入力', '開催日を入力してください。')
        return
      }
      if (!row.startTime) {
        await dialogs.showErrorDialog('受付開始時間 未入力', '受付開始時間を入力してください。')
        return
      }
      if (!row.endTime) {
        await dialogs.showErrorDialog('受付終了時間 未入力', '受付終了時間を入力してください。')
        return
      }
      if (row.startTime > row.endTime) {
        await dialogs.showErrorDialog('受付時間 逆転', '受付時間の開始と終了が逆になっています。')
        return
      }
      if (!row.keyword) {
        await dialogs.showErrorDialog('キーワード 未入力', 'キーワードを入力してください。')
        return
      }
      this.loading = true

      try {
        const res = await backend.postData('evaluationActivity/save', row)

        if (res.data.data != '重複') {
          row.id = res.data.data
          logManager.recording(this, logManager.Loglevel.INFO, 'アポロスクール設定', '登録', row.day + 'の開催日を登録しました。')
          await dialogs.showSuccessDialog('保存完了', '保存しました。')
          this.getData()
        } else {
          await dialogs.showErrorDialog('保存できません', '同じ開催日がすでに登録されています。')
          // this.getData(false)
        }
      } catch (error) {
        alert('保存できませんでした。申し訳ございませんが再度お願いします。')
      }
      this.loading = false
    },

    /**
     * 削除ボタン イベント
     * @param row 対象データ
     */
    async deleteData(row, i) {
      const deleteConf = await dialogs.showWarningConfirmDialog('削除', '本当に削除してよろしいですか？')
      if (deleteConf != 'YES') {
        return
      }
      if (row.id) {
        await backend.deleteData('evaluationActivity/deleteData', { id: row.id })
        this.list.splice(i, 1)
        logManager.recording(this, logManager.Loglevel.INFO, 'アポロスクール設定', '削除', row.day + 'を削除しました。')
      } else {
        this.list.splice(i, 1)
        this.reload++
      }
    }

  }
}
</script>

<style scoped>
.main-form {
  height: calc(100% - 155px);
  min-width: 1140px;
}

.bg-colu {
  height: 40px;
  background: #edecf7;
}

.new {
  background: #e78cc3;
}

.hover-color:hover {
  background: rgba(184, 244, 242, 0.67);
}

 /* ページネーション */
#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}

</style>